/**
 * 加密相关
 */
import { MD5, enc } from 'crypto-js';

export function md5(content: string): string {
  const hash = MD5(content);
  return hash.toString(enc.Hex);
}

export function getRandomStr(len: number): string {
  return Math.random().toString(36)
    .substring(2, len + 2);
}
